import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import CustomLightbox from '../../components/CustomLightbox/CustomLightbox';
import IgnoreProjects from '../../components/IgnoreProjects/IgnoreProjects';
import { API_BASE_URL } from '../../utils/apiConfig';
import './ProjectDetails.css';


const ProjectDetails = () => {

    const { projectId } = useParams(); // Example project ID, replace with dynamic value if needed
    const [project, setProject] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE_URL}/projects/${projectId}`)
            .then(res => {
                if (!res.ok) throw new Error('Failed to fetch project details');
                return res.json();
            })
            .then(data => {
                setProject(data);
            })
            .catch(err => {
                setError(err.message)
            });
    }, [projectId]);

    if (error) return <p>Error: {error}</p>;
    if (!project) return <p className='loading-component'>Loading...</p>;

    // ✅ Parse project_description JSON
    let description = { responsibilities: [], highlights: [] };
    try {
        description = JSON.parse(project.detail_description);
    } catch (e) {
        console.error("Invalid JSON in detail_description", e);
    }

    // const images = [
    //     "image1.png", "springboot-rest-api-article.png", "image1.png", "springboot-rest-api-article.png", "image1.png", "springboot-rest-api-article.png", "image1.png",
    //     // project.image_url
    // ];

    return (
        <div className="project-detail container">

            <section className="project-detail-hero-section" style={{ backgroundImage: `url(${API_BASE_URL}/images/detail-bg.jpg)` }}>
                <div className="project-detail-overlay"></div>
                <div className="project-detail-hero-content">
                    <h2>{project.project_name}</h2>
                    <p>Project &gt; {project.client_name}</p>
                </div>
            </section>

            <main className="project-detail-content-grid">
                <div className="project-detail-main-content">
                    <div className="project-detail-card">
                        <div className="project-detail-header">
                            <h2>{project.project_name}</h2>
                            <span className="project-detail-tag">{project.service_type}</span>
                        </div>
                        <p className="project-detail-industry">Industry: {project.industry}</p>
                        {/* <p className="project-detail-duration">Duration: Dec 2022 to Feb 2023</p> */}
                        <Link to={project.project_link} target="_blank" className="project-detail-live-demo" rel="noopener noreferrer">Live Demo</Link>
                        <hr />
                        <div className="project-detail-description">
                            <p>{project.project_description}</p>
                            {/* <h4>Responsibility:</h4>
                            <ul>
                                <li>The project involves gathering requirements, developing a user interface with all device responsive layouts, and monitoring and improving front-end performance.</li>
                                <li>Optimizing on-page SEO for enhanced web functionality and search engine visibility.</li>
                            </ul> */}
                            <h4>Detailed Desctiption:</h4>
                            <h3>Responsibilities & Contributions</h3>
                            <ul>
                                {description.responsibilities.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>

                            <h3>Project Highlights</h3>
                            <ul>
                                {description.highlights.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    {/* <CustomLightbox images={images} /> */}

                    <div className="project-detail-gallery">
                    {project.screenshots && project.screenshots.length > 0 ? (
                        <CustomLightbox images={project.screenshots} />
                    ) : (
                        <p>
                        Screenshots will be updated soon. Until then, catch up with the live demo above!
                        </p>
                    )}
                    </div>


                </div>

                <aside className="project-detail-sidebar">
                    <div className="project-detail-other-projects">
                        <h4>Other Projects:</h4>
                        <IgnoreProjects currentProjectId={projectId} />
                    </div>
                </aside>
            </main>
        </div>
    )
}

export default ProjectDetails